import type { QueryClient } from '@tanstack/react-query';

const PATIENT_SCOPED_QUERY_ROOTS = new Set([
  'portal-appointments',
  'portal-billing',
  'portal-records',
]);

export async function clearPortalPatientData(
  queryClient: QueryClient,
  options: { includeAccountData?: boolean } = {}
): Promise<void> {
  if (options.includeAccountData) {
    await queryClient.cancelQueries();
    queryClient.clear();
    return;
  }

  const isPatientScoped = (queryKey: readonly unknown[]) => {
    const [root, scope] = queryKey;
    return PATIENT_SCOPED_QUERY_ROOTS.has(String(root))
      || (root === 'portal-profiles' && scope === 'home');
  };

  await queryClient.cancelQueries({
    predicate: (query) => isPatientScoped(query.queryKey),
  });
  queryClient.removeQueries({
    predicate: (query) => isPatientScoped(query.queryKey),
  });
}
